export const projects = [
  {
    title: 'Disque Tech Fácil',
    description: 'Chatbot integrado ao WhatsApp para apoiar adultos 40+ em tarefas digitais cotidianas, com orientações passo a passo, base de conhecimento e IA.',
    image: '/imagens/disque-tech-facil.svg',
    category: 'Automação',
    github: '',
    live: '',
    tags: ['TCC', 'Chatbot', 'WhatsApp', 'IA', 'Acessibilidade']
  },
  {
    title: 'Naxel Tech',
    description: 'Soluções sob medida em desenvolvimento web, automações, suporte e infraestrutura para simplificar processos e impulsionar negócios.',
    image: '/imagens/naxel-logo-atualizada.jpeg',
    category: 'Sites',
    github: 'https://github.com/PlacidoFjr/NaxelTech',
    live: 'https://naxel-tech.vercel.app/',
    tags: ['Web', 'Automação', 'Consultoria', 'Suporte de TI']
  },
  {
    title: 'Paula Moura Arquitetura',
    description: 'Site institucional para um escritório de arquitetura, com portfólio editorial de projetos, apresentação do escritório e canais de contato.',
    image: '/imagens/paula-moura-arquitetura.png',
    category: 'Sites',
    github: 'https://github.com/PlacidoFjr/PAULA-ARQUI',
    live: 'https://paula-arqui.vercel.app/',
    tags: ['Next.js', 'React', 'TypeScript', 'Arquitetura']
  },
  {
    title: 'LevelFit',
    description: 'Aplicação fitness gamificada para acompanhar treinos, alimentação, hidratação e hábitos. Inclui experiência web e API com autenticação, progresso e missões diárias.',
    image: '/imagens/levelfit-preview.png',
    category: 'Apps',
    github: 'https://github.com/PlacidoFjr/LEVELFIT',
    live: 'https://levelfit-api.vercel.app/',
    tags: ['Next.js', 'TypeScript', 'NestJS', 'Prisma', 'PostgreSQL']
  },
  {
    title: 'Mary Studio Commerce',
    description: 'E-commerce Full Stack com loja, checkout e painel administrativo, incluindo autenticação, estoque, pagamentos, frete e diferentes níveis de acesso.',
    image: '/imagens/mary-studio.jpg',
    category: 'Sites',
    github: '',
    live: 'https://mary-studio-commerce.vercel.app/',
    tags: ['Next.js', 'Supabase', 'PostgreSQL', 'Mercado Pago']
  },
  {
    title: 'Naxel Care',
    description: 'Sistema em desenvolvimento para organizar assistências técnicas: clientes, equipamentos, ordens de serviço, equipe, garantias e retornos.',
    image: '/imagens/naxel-care.png',
    category: 'Apps',
    github: 'https://github.com/PlacidoFjr/NAXEL-CARE',
    live: '',
    tags: ['React', 'Assistência técnica', 'Ordens de serviço', 'Em desenvolvimento']
  },
  {
    title: 'EconomizeIA',
    description: 'Aplicação de finanças pessoais com painel, assistente para consultar dados e organização de gastos e pagamentos.',
    image: '/imagens/economizeia.png',
    category: 'Apps',
    github: 'https://github.com/PlacidoFjr/Economizeia',
    live: 'https://economizeia.vercel.app/',
    tags: ['React', 'FastAPI', 'Finanças', 'IA']
  },
  {
    title: 'Bot do Mais Aproveitamento',
    description: 'Projeto de bot de suporte para orientar usuários do Mais Aproveitamento com respostas baseadas na documentação do aplicativo.',
    image: '/imagens/mais-aproveitamento-bot.svg',
    category: 'Automação',
    github: '',
    live: '',
    tags: ['Chatbot', 'Suporte', 'Base de conhecimento', 'Em desenvolvimento']
  },
  {
    title: 'Villa Dolce Ateliê',
    description: 'Site de marca e catálogo para apresentar cestas afetivas e produtos artesanais, feito com React e Vite.',
    image: '/imagens/villa-dolce.jpeg',
    category: 'Sites',
    imageFit: 'contain',
    imageBackground: '#f6eee0',
    github: 'https://github.com/PlacidoFjr/VillaDolce',
    live: 'https://villa-dolce.vercel.app/',
    tags: ['React', 'Vite', 'Catálogo', 'E-commerce']
  },
  {
    title: 'Bank Statement Test Editor',
    description: 'Ferramenta local para importar, revisar e exportar extratos de teste, com OCR opcional e marca d’água obrigatória de documento sem validade bancária.',
    image: '/imagens/statement-editor.svg',
    category: 'Ferramentas',
    github: '',
    live: '',
    tags: ['Python', 'Streamlit', 'OCR', 'Documento de teste']
  },
  {
    title: 'Automação de Prospecção B2B',
    description: 'Ferramentas internas da Naxel e da ORBE para organizar pesquisa, qualificação e acompanhamento de oportunidades comerciais.',
    image: '/imagens/prospeccao-b2b.svg',
    category: 'Automação',
    github: '',
    live: '',
    tags: ['Automação', 'Prospecção', 'Painel interno', 'Dados anonimizados']
  },
  {
    title: 'Sopro Devocional',
    description: 'Aplicativo mobile de devocionais diários, com leitura, reflexão, oração, favoritos e acompanhamento pessoal.',
    image: '/imagens/sopro-devocional.png',
    category: 'Apps',
    github: 'https://github.com/PlacidoFjr/Sopro',
    live: '',
    tags: ['React Native', 'Expo', 'Mobile', 'Projeto pessoal']
  },
];
